<script lang="ts">const { isOpen = false } = $props();
</script>

<div class="chevron-container" class:isOpen>
  <svg class="chevron-left" width="10" height="10" viewBox="0 0 6 6" fill="none">
    <path d="M4 1L1 4" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
  <svg class="chevron-right" width="10" height="10" viewBox="0 0 6 6" fill="none">
    <path d="M4 1L1 4" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.chevron-container {
  display: inline-block;
  width: 16px;
  margin-left: 3px;
}
.chevron-container .chevron-left,
.chevron-container .chevron-right {
  display: inline-block;
  max-width: none;
  stroke: var(--color-text);
  transition: transform 400ms cubic-bezier(0.4, 0, 0.2, 1);
}
.chevron-container .chevron-left {
  transform: rotate(90deg);
}
.chevron-container .chevron-right {
  transform: translateX(-7px);
}
.chevron-container.isOpen .chevron-left {
  transform: rotateX(0deg);
}
.chevron-container.isOpen .chevron-right {
  transform: rotate(90deg) translateX(0) translateY(10px);
}</style>
